import React from "react";
import { Tooltip } from "@mui/material";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { AvailableFareSegmentModel } from "WebApiClient";
import IncServices, { GetIcon } from "components/Shared/IncServices";

interface Props {
    segments: AvailableFareSegmentModel[];
}

export const RenderIncludedServices: React.FC<Props> = ({ segments }) => {
    return (
        <span className="ancillaries text-s">
            {segments.map((segment, index) => {
                const combinedHints = Array.from(
                    new Map(
                        segment.includedServices!
                            .flatMap(item =>
                                item.services!.map(service => ({
                                    hint: service.hint,
                                    type: service.type,
                                    subType: service.subType,
                                }))
                            )
                            .map(obj => [obj.hint, obj])
                    ).values()
                );

                return (
                    <span key={`included-${index}`}>
                        <Tooltip
                            title={
                                <ul style={{ listStyleType: "none", padding: 0, margin: 0 }}>
                                    {combinedHints.map((sub, subIndex) => (
                                        <li key={`hint-${subIndex}`}>
                                            <FontAwesomeIcon icon={GetIcon(sub)} /> {sub.hint}
                                        </li>
                                    ))}
                                </ul>
                            }
                        >
                            <span className="parentIconsClass">
                                {segment.includedServices.map((mainGroup, i) => (
                                    <IncServices
                                        key={`inc-${index}-${i}`}
                                        data={mainGroup}
                                        combinedHints={combinedHints}
                                    />
                                ))}
                            </span>
                        </Tooltip>
                        <br />
                    </span>
                );
            })}
        </span>
    );
};
